import { Component, EventEmitter, Inject, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { TmModalComponent, GlobalComponentService } from '@techmore/global';
import { AppUploadFile, NewUploadSetting } from '../../../../share/entity/upload-file';
import { onUploadFailedEvent } from '../../../../util';
import { HttpEvent } from '@angular/common/http';
import { Observable, Subscription } from 'rxjs';
import { UploadService } from '../../../../share/service/upload.service';
import { IS_BROWSER_TOKEN } from '../../../../share/tokens/is-browser.token';

@Component({
  selector: 'app-image-upload-modal',
  templateUrl: './image-upload-modal.component.html',
  styleUrls: ['./image-upload-modal.component.scss']
})
export class ImageUploadModalComponent implements OnDestroy {
  @ViewChild(TmModalComponent, {static: false}) modal: TmModalComponent;
  /** 圖片是否為單檔案上傳，預設為真 */
  @Input() singleImage: boolean = true;
  /** 點擊確定圖擋上傳按鈕後發出 */
  @Output() imagesChange = new EventEmitter<{pc: AppUploadFile[], mobile: AppUploadFile[]}>();
  /** 上傳的電腦版檔案陣列 */
  protected _pcFiles: AppUploadFile[]|undefined;
  /** 上傳的電腦版檔案陣列 */
  public get pcFiles(): AppUploadFile[]|undefined {
    return this._pcFiles;
  }
  public set pcFiles(files: AppUploadFile[]|undefined) {
    this._pcFiles = files;
  }
  /** 上傳的手機版檔案陣列 */
  protected _mobileFiles: AppUploadFile[]|undefined;
  /** 上傳的手機版檔案陣列 */
  public get mobileFiles(): AppUploadFile[]|undefined {
    return this._mobileFiles;
  }
  public set mobileFiles(files: AppUploadFile[]|undefined) {
    this._mobileFiles = files;
  }
  public readonly onUploadFailedEvent = onUploadFailedEvent;
  public uploadSetting: NewUploadSetting;
  public uploadFile2Server: (type: string, formData: FormData) => Observable<HttpEvent<any>>;
  /** 載入檔案上傳設定訂閱 */
  protected _loadUploadSettingSubc: Subscription;

  constructor(
    protected uploadService: UploadService,
    @Inject(IS_BROWSER_TOKEN) public isBrowser: boolean,
    public globalComponentService: GlobalComponentService,
  ) {
    this.uploadFile2Server = this.uploadService.uploadFile2Server;

    this._loadUploadSettingSubc = this.uploadService.getUploadSetting('image').subscribe((uploadSetting: NewUploadSetting) => {
      this.uploadSetting = uploadSetting;
    });
  }

  ngOnDestroy(): void {
    if (this.modal.isOpened) {
      this.modal.close();
    }
    if (this._loadUploadSettingSubc) {
      this._loadUploadSettingSubc.unsubscribe();
      delete this._loadUploadSettingSubc;
    }
  }

  open(filePayload?: {pc: AppUploadFile[], mobile: AppUploadFile[]}) {
    if (filePayload) {
      this._pcFiles = JSON.parse(JSON.stringify(filePayload.pc));
      this._mobileFiles = JSON.parse(JSON.stringify(filePayload.mobile));
    } else {
      this._pcFiles = [];
      this._mobileFiles = [];
    }
    return this.modal.open();
  }

  close() {
    return this.modal.close();
  }

  onCancel() {
    delete this._pcFiles;
    delete this._mobileFiles;
  }

  onConform() {
    if (this._pcFiles && this._pcFiles.length) {
      this.imagesChange.emit({pc: this._pcFiles, mobile: this._mobileFiles});
    }
    this.onCancel();
  }
}
